import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo-container">
        <img 
          src="https://cdn.wrappedbot.com/overseerpfp.jpg" 
          alt="Overseer Icon" 
          className="w-10 h-10 rounded-xl"
        />
        <Link to="/" className="text-xl font-semibold">Overseer</Link>
      </div>
      <ul className="nav-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/docs">Documentation</Link></li>
        <li><Link to="/premium">Premium</Link></li>
        <li><Link to="/beta">Beta</Link></li>
        <li className="relative group">
          <button className="flex items-center gap-1">
            Legal
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div className="absolute right-0 mt-2 w-48 bg-gray-custom-800 rounded-lg shadow-lg py-2 hidden group-hover:block">
            <Link to="/legal/terms" className="block px-4 py-2 hover:bg-gray-custom-700">Terms of Service</Link>
            <Link to="/legal/privacy" className="block px-4 py-2 hover:bg-gray-custom-700">Privacy Policy</Link>
          </div>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;